<template>
  <section id="partners" class="partners-section">
    <div class="bg-pattern"></div>

    <div class="section-header" :class="{ 'animate': isInView }">
      <div class="header-line"></div>
      <h2 class="section-title">Our <span>Partners</span></h2>
      <div class="header-line"></div>
    </div>

    <p class="section-subtitle" :class="{ 'animate': isInView }">
      Trusted collaborations that strengthen our solutions and expand our reach.
    </p>

    <div class="marquee-container" :class="{ 'animate': isInView }">
      <div class="marquee-track">
        <div
          class="logo-card"
          v-for="(logo, index) in duplicatedLogos"
          :key="index"
          :aria-hidden="index >= logos.length ? 'true' : null"
        >
          <img :src="logo" :alt="`Partner logo ${(index % logos.length) + 1}`" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PartnersSection',
  data() {
    return {
      isInView: false,
      logos: [
        require('@/assets/Partners/1.png'),
        require('@/assets/Partners/2.png'),
        require('@/assets/Partners/3.webp'),
        require('@/assets/Partners/4.png'),
        require('@/assets/Partners/5.webp'),
        require('@/assets/Partners/6.jpg'),
        require('@/assets/Partners/7.jpg'),
        require('@/assets/Partners/8.webp'),
        require('@/assets/Partners/9.png')
      ]
    }
  },
  computed: {
    duplicatedLogos() {
      return [...this.logos, ...this.logos];
    }
  },
  mounted() {
    window.addEventListener('scroll', this.checkView);
    this.checkView();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.checkView);
  },
  methods: {
    checkView() {
      const section = document.querySelector('.partners-section');
      if (!section) return;
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        this.isInView = true;
      }
    }
  }
}
</script>

<style scoped>
.partners-section {
  padding: 8rem 2rem;
  background-color: #fcfaf2;
  position: relative;
  overflow: hidden;
}

.bg-pattern {
  position: absolute;
  inset: 0;
  background-image: url('../assets/pattern-bg.png');
  background-size: 300px;
  opacity: 0.03;
  pointer-events: none;
  z-index: 0;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.section-header.animate {
  opacity: 1;
  transform: translateY(0);
}

.header-line {
  height: 2px;
  width: 80px;
  background: linear-gradient(90deg, transparent, #d1c06e, transparent);
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
  margin: 0;
}

.section-title span {
  background: linear-gradient(45deg, #d1c06e, #e0d394);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.section-subtitle {
  text-align: center;
  font-size: 1.1rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto 4rem auto;
  position: relative;
  z-index: 1;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease 0.15s, transform 0.8s ease 0.15s;
}

.section-subtitle.animate {
  opacity: 1;
  transform: translateY(0);
}

.marquee-container {
  position: relative;
  z-index: 1;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
  mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
  opacity: 0;
  transition: opacity 0.8s ease 0.3s;
}

.marquee-container.animate {
  opacity: 1;
}

.marquee-track {
  display: flex;
  width: max-content;
  animation: marquee-scroll 40s linear infinite;
  will-change: transform;
}

.marquee-container:hover .marquee-track {
  animation-play-state: paused;
}

@keyframes marquee-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.logo-card {
  flex-shrink: 0;
  margin-right: 2rem;
  height: 140px;
  min-width: 180px;
  padding: 1.5rem 2rem;
  background: #ffffff;
  border: 1px solid rgba(209, 192, 110, 0.15);
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(209, 192, 110, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.4s ease, box-shadow 0.4s ease, border-color 0.4s ease;
}

.logo-card img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.logo-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(209, 192, 110, 0.2);
  border-color: rgba(209, 192, 110, 0.3);
}

@media (max-width: 768px) {
  .partners-section {
    padding: 5rem 1rem;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .header-line {
    width: 40px;
  }

  .section-subtitle {
    font-size: 1rem;
    margin-bottom: 3rem;
  }

  .logo-card {
    height: 90px;
    min-width: 120px;
    margin-right: 1.25rem;
    padding: 1rem 1.25rem;
    border-radius: 12px;
  }

  .marquee-track {
    animation-duration: 25s;
  }
}

@media (prefers-reduced-motion: reduce) {
  .section-header,
  .section-subtitle,
  .marquee-container {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .marquee-container {
    -webkit-mask-image: none;
    mask-image: none;
  }

  .marquee-track {
    animation: none;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 1.5rem;
  }

  .logo-card {
    margin-right: 0;
  }
}
</style>
